import React, { useCallback, ReactElement } from 'react';
import Menu from '../menu/menu.component';
import MenuItem from '../menu-item/menu-item.component';
import ListItemText from '../list-item-text/list-item-text.component';
import ListItemImage from '../list-item-image/list-item-image.component';
import useStylesSearchQuickMenu from './search-quick-menu.styles';

const SearchQuickMenu: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    menuAnchor,
    typeLabelMap,
    typeDefaultImageMap,
    searchResultItemList,
    onCloseActionMenu,
    onSearchQuickResultItemClick,
  } = props;

  const { classes } = useStylesSearchQuickMenu();

  const closeActionMenu: Function = useCallback((event: React.MouseEvent<Element, MouseEvent>): void => {
    if (onCloseActionMenu) {
      onCloseActionMenu(event);
    }
  }, []);

  return (
    <Menu
      withShadow
      withNoFocus
      isHidden={!searchResultItemList.length}
      menuAnchor={menuAnchor}
      menuClassName={classes.searchQuickMenu}
      onClose={closeActionMenu}
    >
      {
        searchResultItemList.map((searchResultItem: SearchQuickResultItem): ReactElement => (
          <MenuItem
            key={searchResultItem.id}
            onClick={(event: React.MouseEvent<Element, MouseEvent>): void => {
              if (onSearchQuickResultItemClick) {
                onSearchQuickResultItemClick(event, searchResultItem);
              }
            }}
          >
            <ListItemImage
              isSmall
              text={searchResultItem.name}
              link={searchResultItem.photo || typeDefaultImageMap[searchResultItem.entityType]}
            />
            <ListItemText isInline className={classes.searchQuickMenuItemTextName}>
              {searchResultItem.name}
            </ListItemText>
            <ListItemText
              isBlockRight
              subText={(searchResultItem.entityType && typeLabelMap[searchResultItem.entityType]) || ''}
            />
          </MenuItem>
        ))
      }
    </Menu>
  );
});

export default SearchQuickMenu;
